import React from 'react';
import { Link } from 'react-router-dom';
import PageHead from '../components/PageHead';
import { SUPPORT_WHATSAPP } from '../config/site';
import { usePageMeta } from '../hooks/usePageMeta';

// Google Play's "Delete account URL" points here. Keep the steps in step with the app (Ajustes → Eliminar mi cuenta).
const DeleteAccount: React.FC = () => {
  usePageMeta(
    'Eliminar tu cuenta · Violeta',
    'Cómo eliminar tu cuenta de Violeta y tus datos desde la app, qué se borra y qué puede quedar.',
  );

  return (
    <>
      <PageHead
        title="Eliminar tu cuenta y tus datos"
        crumb="Eliminar cuenta"
        lead="Tú decides, cuando quieras y sin dar explicaciones."
      />

      <div className="legal">
        <div className="container">
          <section className="lsec" aria-labelledby="como">
            <span className="lsec__num" aria-hidden="true">01</span>
            <div className="prose">
              <h2 id="como">Cómo eliminar tu cuenta desde la app</h2>
              <p>
                Puedes eliminar tu cuenta de Violeta cuando quieras, tú sola, sin dar explicaciones. Es inmediato y no
                se puede deshacer.
              </p>
              <ol>
                <li>Abre la app Violeta e inicia sesión.</li>
                <li>Abre el menú y entra a <strong>Ajustes</strong>.</li>
                <li>Toca <strong>«Eliminar mi cuenta»</strong> y confirma.</li>
              </ol>
            </div>
          </section>

          <section className="lsec" aria-labelledby="borra">
            <span className="lsec__num" aria-hidden="true">02</span>
            <div className="prose">
              <h2 id="borra">Qué se elimina</h2>
              <ul>
                <li>Tu cuenta y tu acceso (correo y contraseña).</li>
                <li>
                  Tu perfil guardado en nuestro servidor: nombre, correo, teléfono, cédula, estado de residencia, fecha
                  de nacimiento y cualquier otro dato que hayas escrito en tu perfil.
                </li>
                <li>
                  El historial de ubicaciones que la app guardó en nuestro servidor (botón de emergencia y Acompáñame).
                </li>
                <li>Tus contactos de emergencia guardados en tu teléfono.</li>
              </ul>
            </div>
          </section>

          <section className="lsec" aria-labelledby="queda">
            <span className="lsec__num" aria-hidden="true">03</span>
            <div className="prose">
              <h2 id="queda">Qué puede quedar</h2>
              <ul>
                <li>
                  Los conteos anónimos de uso de la app. No llevan tu nombre ni están ligados a tu cuenta; al eliminar
                  tu cuenta, la app reemplaza el identificador aleatorio de tu instalación por uno nuevo.
                </li>
                <li>
                  Las copias de seguridad automáticas del servicio donde se aloja la base de datos pueden conservar tus
                  datos hasta 7 días antes de borrarse solas.
                </li>
                <li>
                  Los mensajes y enlaces que ya enviaste a tus contactos: no podemos recuperarlos de sus teléfonos.
                </li>
              </ul>
            </div>
          </section>

          <section className="lsec" aria-labelledby="sin-app">
            <span className="lsec__num" aria-hidden="true">04</span>
            <div className="prose">
              <h2 id="sin-app">Si ya no tienes la app o no puedes entrar</h2>
              <p>
                Instala Violeta de nuevo e inicia sesión con tu correo (si olvidaste la contraseña, usa «Olvidé mi
                contraseña»). Después sigue los pasos de arriba.
              </p>
              <p>
                Si aun así no puedes, escríbenos por WhatsApp al <a href={SUPPORT_WHATSAPP}>+58 (414) 217-5746</a>{' '}
                indicando el correo con el que te registraste, y eliminaremos tu cuenta y tus datos.
              </p>
              <p>
                Más información sobre qué datos usamos y por qué en nuestra{' '}
                <Link to="/politica-de-privacidad">política de privacidad</Link>.
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default DeleteAccount;
